import { BarChart3, AlertTriangle, CreditCard, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAIAssistant } from '@/contexts/ai-assistant-context';

interface QuickAction {
  id: string;
  label: string;
  prompt: string;
  icon: string;
}

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  BarChart3,
  AlertTriangle,
  CreditCard,
  Sparkles,
};

const QUICK_ACTIONS: QuickAction[] = [
  {
    id: 'overdue-accounts',
    label: 'Show overdue accounts',
    prompt: 'Show me a summary of overdue accounts',
    icon: 'AlertTriangle',
  },
  {
    id: 'aging-analysis',
    label: 'Ageing analysis',
    prompt: 'Show me the ageing analysis across all companies',
    icon: 'BarChart3',
  },
  {
    id: 'collection-summary',
    label: 'Collection summary',
    prompt: 'Give me a summary of active collection cases',
    icon: 'CreditCard',
  },
];

export function AIAssistantSuggestions() {
  const { sendMessage } = useAIAssistant();

  const handleSuggestionClick = (prompt: string) => {
    sendMessage(prompt);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Sparkles className="h-4 w-4 text-primary" />
        <h3 className="text-sm font-medium">Quick Actions</h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {QUICK_ACTIONS.map((action) => {
          const Icon = iconMap[action.icon] ?? Sparkles;
          return (
            <Button
              key={action.id}
              variant="outline"
              size="sm"
              className="gap-2 h-8 text-xs"
              onClick={() => handleSuggestionClick(action.prompt)}
            >
              <Icon className="h-3 w-3" />
              {action.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
